/* SandyClair — JS propio de las secciones personalizadas (prefijo sc-) */
(function () {
  'use strict';

  // Varias secciones incluyen este archivo (se cargaba 4 veces en la ficha): cada clic se atendía 4 veces
  // y las flechas de la galería se saltaban fotos. Solo se ejecuta la primera vez (3 oct 2026).
  if (window.__scScriptsCargado) return;
  window.__scScriptsCargado = true;

  function initReveal() {
    var items = document.querySelectorAll('.sc-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('sc-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sc-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    items.forEach(function (el) { observer.observe(el); });
  }

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-sc-count'));
    if (isNaN(target)) return;
    var duration = 1400;
    var start = null;
    var suffix = el.getAttribute('data-sc-count-suffix') || '';
    function step(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.floor(eased * target);
      el.textContent = value.toLocaleString('es-ES') + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = target.toLocaleString('es-ES') + suffix;
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var counters = document.querySelectorAll('[data-sc-count]');
    if (!counters.length) return;
    if (!('IntersectionObserver' in window)) {
      counters.forEach(animateCount);
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    counters.forEach(function (el) { observer.observe(el); });
  }

  function initGallery() {
    document.querySelectorAll('[data-sc-gallery]').forEach(function (gallery) {
      var viewport = gallery.querySelector('[data-sc-gallery-viewport]');
      var slides = gallery.querySelectorAll('[data-sc-gallery-slide]');
      var thumbs = gallery.querySelectorAll('[data-sc-gallery-thumb]');
      var dots = gallery.querySelectorAll('[data-sc-gallery-dot]');
      var thumbsRail = gallery.querySelector('.sc-gallery__thumbs');
      if (!viewport || !slides.length) return;

      var current = 0;
      var programmatic = false; // true mientras movemos nosotros el carrusel
      var sinSalto = false;     // true mientras la clienta elige foto: cambia el color, pero no salta a la foto principal de ese color

      // Deja la miniatura activa a la vista sin arrastrar la página
      function revealThumb(index) {
        var thumb = thumbs[index];
        if (!thumb || !thumbsRail) return;
        if (thumbsRail.scrollWidth <= thumbsRail.clientWidth) return;
        var destino = thumb.offsetLeft - (thumbsRail.clientWidth - thumb.clientWidth) / 2;
        thumbsRail.scrollTo({ left: Math.max(0, destino), behavior: 'smooth' });
      }

      function setActive(index, avisarVariante) {
        if (index < 0 || index >= slides.length) return;
        current = index;
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
        revealThumb(index);
        if (!avisarVariante) return;
        var ids = (slides[index].getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
        var productRoot = gallery.closest('[data-sc-product]');
        if (ids.length && productRoot && productRoot.scSelectVariantsByIds) {
          sinSalto = true;
          try { productRoot.scSelectVariantsByIds(ids); } finally { sinSalto = false; }
        }
      }

      // Ojo: con scroll-snap-stop:always el navegador cancela los desplazamientos
      // animados por código, así que el salto va sin animación. Deslizar con el
      // dedo sigue siendo suave porque de eso se encarga el propio sistema.
      function goTo(index) {
        if (index < 0 || index >= slides.length) return;
        programmatic = true;
        viewport.scrollTo({ left: index * viewport.clientWidth, behavior: 'auto' });
        window.setTimeout(function () { programmatic = false; }, 250);
      }

      // El dedo manda: cuando el scroll se para, vemos en qué foto ha quedado
      var reposo;
      viewport.addEventListener('scroll', function () {
        window.clearTimeout(reposo);
        reposo = window.setTimeout(function () {
          if (!viewport.clientWidth) return;
          var index = Math.round(viewport.scrollLeft / viewport.clientWidth);
          if (index === current) return;
          setActive(index, !programmatic);
        }, 90);
      }, { passive: true });

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          goTo(i);
          setActive(i, true);
        });
      });

      // Flechas del teclado cuando el carrusel tiene el foco
      viewport.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var destino = current + (event.key === 'ArrowRight' ? 1 : -1);
        goTo(destino);
        setActive(destino, true);
      });

      // Flechas de la foto grande (solo se ven con ratón): al final vuelve a la primera
      var prev = gallery.querySelector('[data-sc-gallery-prev]');
      var next = gallery.querySelector('[data-sc-gallery-next]');
      function moverFoto(paso) {
        var destino = (current + paso + slides.length) % slides.length;
        goTo(destino);
        setActive(destino, true);
      }
      if (prev) prev.addEventListener('click', function () { moverFoto(-1); });
      if (next) next.addEventListener('click', function () { moverFoto(1); });

      // Flechas de la fila de miniaturas: solo aparecen si no caben todas
      var thumbsPrev = gallery.querySelector('[data-sc-thumbs-prev]');
      var thumbsNext = gallery.querySelector('[data-sc-thumbs-next]');
      function actualizarFlechasMiniaturas() {
        if (!thumbsRail) return;
        var sobra = thumbsRail.scrollWidth - thumbsRail.clientWidth;
        if (thumbsPrev) thumbsPrev.hidden = !(sobra > 2 && thumbsRail.scrollLeft > 2);
        if (thumbsNext) thumbsNext.hidden = !(sobra > 2 && thumbsRail.scrollLeft < sobra - 2);
      }
      function moverMiniaturas(direccion) {
        thumbsRail.scrollBy({ left: direccion * thumbsRail.clientWidth * 0.8, behavior: 'smooth' });
      }
      if (thumbsRail) {
        if (thumbsPrev) thumbsPrev.addEventListener('click', function () { moverMiniaturas(-1); });
        if (thumbsNext) thumbsNext.addEventListener('click', function () { moverMiniaturas(1); });
        thumbsRail.addEventListener('scroll', actualizarFlechasMiniaturas, { passive: true });
        window.addEventListener('resize', actualizarFlechasMiniaturas);
        window.addEventListener('load', actualizarFlechasMiniaturas);
        actualizarFlechasMiniaturas();
      }

      // Para que el selector de color pueda traer su foto
      gallery.scShowVariantImage = function (variantId) {
        if (sinSalto) return;
        for (var i = 0; i < slides.length; i++) {
          var ids = (slides[i].getAttribute('data-variant-ids') || '').split(',');
          if (ids.indexOf(String(variantId)) !== -1) {
            // Comparamos contra el scroll real, no contra `current`: si los dos
            // se desincronizan, la foto se quedaba parada en la anterior.
            var visible = viewport.clientWidth ? Math.round(viewport.scrollLeft / viewport.clientWidth) : 0;
            if (i !== visible) goTo(i);
            setActive(i, false);
            return;
          }
        }
      };

      setActive(0, false);
    });
  }

  function initVariantPicker() {
    document.querySelectorAll('[data-sc-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-sc-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = root.querySelector('[data-sc-variant-id]');
      var priceEl = root.querySelector('[data-sc-price]');
      var comparePriceEl = root.querySelector('[data-sc-compare-price]');
      var saveEl = root.querySelector('[data-sc-save]');
      var submitBtn = root.querySelector('[data-sc-submit]');
      var optionGroups = root.querySelectorAll('[data-sc-option-index]');

      function currentSelection() {
        var selected = [];
        optionGroups.forEach(function (group) {
          var active = group.querySelector('.sc-swatch.is-selected');
          selected.push(active ? active.getAttribute('data-value') : null);
        });
        return selected;
      }

      function findVariant(selection) {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selection[i]; });
        });
      }

      function formatMoney(cents) {
        return (Number(cents) / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
      }

      function updateAvailability(selection) {
        optionGroups.forEach(function (group, groupIndex) {
          var buttons = group.querySelectorAll('.sc-swatch');
          buttons.forEach(function (btn) {
            var testSelection = selection.slice();
            testSelection[groupIndex] = btn.getAttribute('data-value');
            var possible = variants.some(function (v) {
              return v.options.every(function (opt, i) {
                return testSelection[i] === null || opt === testSelection[i];
              });
            });
            btn.disabled = !possible;
          });
        });
      }

      // Grupo de talla que la clienta aún no ha elegido (null si ya está todo elegido)
      function grupoSinElegir() {
        var falta = null;
        optionGroups.forEach(function (group) {
          if (!falta && group.getAttribute('data-sc-requiere') === '1' && !group.querySelector('.sc-swatch.is-selected')) falta = group;
        });
        return falta;
      }
      root.scFaltaTalla = grupoSinElegir;

      // Sin talla elegida no se compra: se lleva a la clienta a la talla y se le avisa
      root.scPedirTalla = function () {
        var grupo = grupoSinElegir();
        if (!grupo) return false;
        var aviso = grupo.querySelector('[data-sc-aviso-talla]');
        if (aviso) aviso.hidden = false;
        grupo.classList.remove('is-falta');
        void grupo.offsetWidth; // reinicia la animación
        grupo.classList.add('is-falta');
        grupo.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      };

      function refresh() {
        var selection = currentSelection();
        var variant = findVariant(selection);
        updateAvailability(selection);

        var submitBtnText = submitBtn ? submitBtn.querySelector('[data-sc-submit-text]') : null;
        var gallery = root.querySelector('[data-sc-gallery]');

        if (!variant) {
          var faltaTalla = grupoSinElegir();
          if (submitBtn) {
            // Si solo falta la talla, el botón se puede pulsar: lleva a la talla y avisa (lo hace el guardián del formulario)
            submitBtn.disabled = !faltaTalla;
            submitBtn.classList.toggle('is-elige-talla', !!faltaTalla);
            if (submitBtnText) {
              submitBtnText.textContent = faltaTalla
                ? (submitBtn.getAttribute('data-text-choose') || 'Elige tu talla')
                : (submitBtn.getAttribute('data-text-unavailable') || 'No disponible');
            }
          }
          // Aunque falte la talla, al tocar un color se enseña su foto
          if (faltaTalla && gallery && gallery.scShowVariantImage) {
            var parecida = variants.find(function (v) {
              return v.featured_image && v.options.every(function (opt, i) { return selection[i] === null || opt === selection[i]; });
            });
            if (parecida) gallery.scShowVariantImage(parecida.id);
          }
          return;
        }

        optionGroups.forEach(function (group) {
          var aviso = group.querySelector('[data-sc-aviso-talla]');
          if (aviso) aviso.hidden = true;
          group.classList.remove('is-falta');
        });
        if (submitBtn) submitBtn.classList.remove('is-elige-talla');

        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = formatMoney(variant.compare_at_price);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
        if (saveEl) {
          var pct = 0;
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          }
          if (pct >= 5) {
            saveEl.textContent = 'Ahorro del ' + pct + '%';
            saveEl.style.display = '';
          } else {
            saveEl.style.display = 'none';
          }
        }
        if (submitBtn) {
          if (variant.available) {
            submitBtn.disabled = false;
            if (submitBtnText) submitBtnText.textContent = submitBtn.getAttribute('data-text-add') || 'Añadir a la cesta';
          } else {
            submitBtn.disabled = true;
            if (submitBtnText) submitBtnText.textContent = submitBtn.getAttribute('data-text-soldout') || 'Agotado';
          }
        }

        // Lleva el carrusel a la foto de la variante elegida
        if (variant.featured_image && variant.featured_image.src) {
          if (gallery && gallery.scShowVariantImage) {
            gallery.scShowVariantImage(variant.id);
          }
        }
      }

      optionGroups.forEach(function (group) {
        group.querySelectorAll('.sc-swatch').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            group.querySelectorAll('.sc-swatch').forEach(function (b) { b.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
            refresh();
          });
        });
      });

      // Al hacer clic en una foto de la galería, selecciona la opción (normalmente el color)
      // que comparten todas las variantes asociadas a esa foto, sin tocar las demás opciones (talla).
      root.scSelectVariantsByIds = function (variantIds) {
        var matched = variants.filter(function (v) { return variantIds.indexOf(String(v.id)) !== -1; });
        if (!matched.length) return;
        optionGroups.forEach(function (group, groupIndex) {
          var values = matched.map(function (v) { return v.options[groupIndex]; });
          var allSame = values.every(function (v) { return v === values[0]; });
          if (!allSame) return;
          var buttons = group.querySelectorAll('.sc-swatch');
          var target = null;
          buttons.forEach(function (btn) {
            if (btn.getAttribute('data-value') === values[0]) target = btn;
          });
          if (target && !target.classList.contains('is-selected')) {
            buttons.forEach(function (b) { b.classList.remove('is-selected'); });
            target.classList.add('is-selected');
          }
        });
        refresh();
      };

      // Guarda de seguridad: si el formulario se envía sin talla (botón fijo de abajo, Enter…), no se añade nada
      var form = root.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        form.addEventListener('submit', function (event) {
          if (!grupoSinElegir()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          root.scPedirTalla();
        }, true);
      }

      refresh();
    });
  }

  function initCountdown() {
    document.querySelectorAll('[data-sc-countdown]').forEach(function (root) {
      var end = new Date(root.getAttribute('data-end')).getTime();
      if (isNaN(end)) return;
      var daysEl = root.querySelector('[data-sc-cd-days]');
      var hoursEl = root.querySelector('[data-sc-cd-hours]');
      var minutesEl = root.querySelector('[data-sc-cd-minutes]');
      var secondsEl = root.querySelector('[data-sc-cd-seconds]');

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          [daysEl, hoursEl, minutesEl, secondsEl].forEach(function (el) { if (el) el.textContent = '00'; });
          clearInterval(timer);
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);
        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-sc-sticky-bar]');
    var trigger = document.querySelector('[data-sc-sticky-trigger]');
    if (!bar || !trigger) return;

    var mainForm = document.querySelector('[data-sc-product] form[data-type="add-to-cart-form"]');
    var button = bar.querySelector('[data-sc-sticky-submit]');
    if (button && mainForm) {
      button.addEventListener('click', function () {
        var productRoot = mainForm.closest('[data-sc-product]');
        if (productRoot && productRoot.scPedirTalla && productRoot.scPedirTalla()) return;
        if (mainForm.requestSubmit) mainForm.requestSubmit();
        else mainForm.submit();
      });
    }

    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(trigger);
  }

  function initSizeGuide() {
    var dialog = document.getElementById('sc-guia-tallas');
    if (!dialog) return;
    document.querySelectorAll('[data-sc-size-guide-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { dialog.showModal(); });
    });
    dialog.querySelectorAll('[data-sc-size-guide-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { dialog.close(); });
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCounters();
    initGallery();
    initVariantPicker();
    initCountdown();
    initStickyBar();
    initSizeGuide();
  });
})();

/* ===================================================================
   Carrito — cuenta atrás de "carrito guardado".
   Un solo intervalo global que reescanea el DOM en cada tick, para que
   siga funcionando cuando Shopify vuelve a pintar el cajón del carrito.
   El plazo se guarda en sessionStorage: no se reinicia al navegar.
   Al llegar a cero NO se vacía nada, solo cambia el mensaje.
=================================================================== */
(function () {
  var CLAVE = 'scCarritoLimite';
  var iniciado = false;

  function limite(minutos) {
    var guardado = null;
    try { guardado = sessionStorage.getItem(CLAVE); } catch (e) {}
    var ahora = Date.now();
    var t = guardado ? parseInt(guardado, 10) : NaN;
    // 23 sep 2026: aunque el plazo ya haya pasado se devuelve el mismo, para que el reloj TERMINE
    // y cambie el mensaje. Antes se creaba otro plazo y volvía a empezar en 10:00: se notaba falso.
    if (!isNaN(t)) return t;
    t = ahora + minutos * 60 * 1000;
    try { sessionStorage.setItem(CLAVE, String(t)); } catch (e) {}
    return t;
  }

  function tick() {
    var cajas = document.querySelectorAll('[data-sc-reserva]');
    if (!cajas.length) return;
    for (var i = 0; i < cajas.length; i++) {
      var caja = cajas[i];
      var reloj = caja.querySelector('[data-sc-reloj]');
      if (!reloj) continue;
      var minutos = parseInt(caja.getAttribute('data-minutos'), 10) || 10;
      var restante = limite(minutos) - Date.now();
      if (restante <= 0) {
        if (!caja.classList.contains('is-agotado')) {
          caja.classList.add('is-agotado');
          var txt = caja.querySelector('.sc-cart-reserva__txt');
          if (txt) txt.textContent = caja.getAttribute('data-texto-fin') || 'Tu carrito sigue guardado. Termina cuando quieras.';
        }
        continue;
      }
      var m = Math.floor(restante / 60000);
      var s = Math.floor((restante % 60000) / 1000);
      var texto = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (reloj.textContent !== texto) reloj.textContent = texto;
    }
  }

  function arrancar() {
    if (iniciado) return;
    iniciado = true;
    tick();
    // Cada 250 ms: tras repintar el cajón el reloj sale como --:-- y así apenas se nota
    setInterval(tick, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();

/* ===================================================================
   Ficha — fecha de llegada bajo el botón (16 sep 2026).
   "Te llega entre el 23 y el 30 de septiembre": hoy + días
   mínimos y máximos del ajuste, con la fecha del móvil de la clienta.
=================================================================== */
(function () {
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
    'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  function sumarDias(dias) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    d.setDate(d.getDate() + dias);
    return d;
  }

  function rango(desde, hasta) {
    if (desde.getMonth() === hasta.getMonth()) {
      return desde.getDate() + ' y el ' + hasta.getDate() + ' de ' + MESES[hasta.getMonth()];
    }
    return desde.getDate() + ' de ' + MESES[desde.getMonth()] + ' y el ' + hasta.getDate() + ' de ' + MESES[hasta.getMonth()];
  }

  function pintar() {
    var bloques = document.querySelectorAll('[data-sc-llegada]');
    for (var i = 0; i < bloques.length; i++) {
      var b = bloques[i];
      var min = parseInt(b.getAttribute('data-min'), 10);
      var max = parseInt(b.getAttribute('data-max'), 10);
      var destino = b.querySelector('[data-sc-llegada-fechas]');
      if (!destino || isNaN(min) || isNaN(max) || max < min) continue;
      destino.textContent = rango(sumarDias(min), sumarDias(max));
      b.hidden = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pintar);
  } else {
    pintar();
  }
})();
